module.exports = __webpack_public_path__ + "static/NO-streaming-video-gamiclub-tallyman.v1-pin/files/6fc2eeb224044b4c73c39ef13fd43f11.png";